import { render, staticRenderFns } from "./AddEditSobrietyQuiz.vue?vue&type=template&id=648ef1fd"
import script from "./AddEditSobrietyQuiz.vue?vue&type=script&lang=js"
export * from "./AddEditSobrietyQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports